  <!-- Ag grid div start -->
    @if(this.userAuthService.checkPermission('MANAGE.USERS.ROLES'))
    {
      <!-- <div class="row">
        <div class="col-12 d-flex justify-content-end align-items-center">
          <button class="mdc-button mdc-button--outlined add-button-height ml-3 btn-lineheight-1" mat-stroked-button (click)="addUser()">
            <span class="mdc-button__ripple"></span>
            <i class="material-icons mdc-button__icon" aria-hidden="true">add</i>
            <span class="mdc-button__label">Add User</span>
          </button>

        </div>
      </div> -->
        <div class="mt-2 pr-0 col-12 d-flex justify-content-end align-items-center mb-05">
  <button class="add-service-btn" (click)="addUser()">+ Add User
    <mat-icon mat-icon-button matSuffix matTooltip="Click on the button to add a new user"
              aria-hidden="true" matTooltipClass="ey-custom-tooltip"
              matTooltipPosition="below" style="margin-bottom: -3px;  align-items: center; vertical-align: middle; font-size: 18px;">
              info
            </mat-icon>
  </button>
  </div>
    }
    <!-- Added cog menu template -->
    <ng-template #userActionsMenu let-useractions>
      <div class="m-t-20">
        <!-- Added disabled logic -->
        <ul class="mdc-list demo-list mdc-elevation--z2 b-white">
          <!-- Added user actions menu for approve access, modify access, revoke access and delete user -->
          <!-- //NOSONAR -->
          <li class="mdc-list-item mdc-ripple-upgraded context-menu-heigth"
            [ngClass]="{'cogdisabled': selectedUsersList.length === 0}">
            &nbsp;<span class="material-symbols-outlined">person_check</span>
            &nbsp;&nbsp;USER_ACTION_APPROVE_ACCESS
          </li>

          <!-- //NOSONAR -->
          <li class="mdc-list-item mdc-ripple-upgraded context-menu-heigth"
            [ngClass]="{'cogdisabled': selectedUsersList.length === 0}">
            <span class="material-symbols-outlined">person_edit</span>
            &nbsp;&nbsp;&nbsp;USER_ACTION_MODIFY_ACCESS
          </li>

          <!-- //NOSONAR -->
          <li class="mdc-list-item mdc-ripple-upgraded context-menu-heigth"
            [ngClass]="{'cogdisabled': selectedUsersList.length === 0}">
            &nbsp;<span class="material-symbols-outlined">person_cancel</span>
            &nbsp;&nbsp;USER_ACTION_REVOKE_ACCESS
          </li>

          <!-- //NOSONAR -->
          <li class="mdc-list-item mdc-ripple-upgraded context-menu-heigth"
            [ngClass]="{'cogdisabled': selectedUsersList.length === 0}">
            &nbsp;<span class="material-symbols-outlined">person_remove</span>
            &nbsp;&nbsp;USER_ACTION_DELETE_USER
          </li>

          <!-- //NOSONAR -->
          <li class="mdc-list-item mdc-ripple-upgraded context-menu-heigth">
            <span class="material-symbols-outlined">update</span>
            &nbsp;&nbsp;&nbsp;BULK_ACTION_STATUS
          </li>
        </ul>
      </div>
    </ng-template>
    <div id="userManagement">
      <!-- total user div -->
      <div class="row">
        <div class="pb-10 col-4">
          <!-- filter icon start -->
          <button class="btn btn-link btn-icon-text bulk-action-btn" mat-stroked-button [matMenuTriggerFor]="appAdditionalFilter"
            uib-dropdown-toggle type="button">
            <span title="ADDITIONAL_FILTERS" class="material-symbols-outlined" style="font-size: inherit;color:black;">
              filter_list
            </span>
          </button>
          <!-- filter icon end -->
          <!-- span to show total user -->
          <span *ngIf="totalRecords" class="mdc-data-table__header-cell" style="margin-left: -10px;">
            {{totalRecords}} <em class="selectedRecordText">Total Users</em>
          </span>
          <!-- span to show selected user count -->
          <!-- <span *ngIf="selectedUserIds.length > 0" class="mdc-data-table__header-cell" style="margin-left: -10px;">
          | &nbsp; {{ isSelectAll ? (totalRecords - unSelectedUsers.length) : selectedUserIds.length }} <em class="selectedRecordText">SELECTED</em>
        </span> -->
        </div>
        <!-- mat chip list div start -->
        <div class="col-8">
          <!-- mat chip list -->
          <mat-chip-listbox>
            <mat-chip-option
              style="min-height: 21px;font-size: 10px;padding-left: 6px;padding-right: 6px;background-color: #E0E0E5"
              *ngFor="let val of selectedadditionalFilterValues">
              {{val}}
              <!-- //NOSONAR --><mat-icon matChipRemove
                style="font-size: 12px;height: 12px;margin-left: 4px;color: rgb(0 0 0 / 84%);opacity: 1"
                (click)="cancelAdditionalFilterChipAGGrid(val)">cancel</mat-icon>
            </mat-chip-option>

          </mat-chip-listbox>
        </div>
        <!-- mat chip list div end -->
      </div>
      <!-- filter option menu end -->
      <!-- filter option menu start -->
      <mat-menu #appAdditionalFilter="matMenu">
        <div class="form-group mb-0 mdc-form-field formfield-material userStatusFilterTrigger" width="70px">
          <!-- mat select for status column filter start -->
          <mat-select  multiple class="form-control"
            panelClass="userStatusFilterControl" (openedChange)="applyAdditionalFilter()"
            [(ngModel)]="selectedadditionalFilterValues">
            <span *ngFor="let filterCase of filterCaseOptionList; let i=index">
              <!-- mat option -->
              <mat-option [value]="filterCase">
                {{filterCase}}
              </mat-option>
              <mat-divider *ngIf="i==3"></mat-divider>
            </span>
          </mat-select>
          <!-- mat select for status column filter start end -->
        </div>
      </mat-menu>
      <!-- total user div end -->
      <!-- Ag grid start -->
      <!-- Added gridOptions -->
      <!-- <ag-grid-angular [style]="styleChipDiv" class="ag-theme-material user-managementt-grid" [rowHeight]="rowHeight"
        [paginationPageSize]="paginationPageSize" [rowModelType]="rowModelType"
        [columnDefs]="columnDefs" id="gridUsers" [defaultColDef]="defaultColDef" (gridReady)="onGridReady($event)"
        [overlayNoRowsTemplate]="overlayNoRowsTemplate" [sideBar]="sideBar"
        [infiniteInitialRowCount]="infiniteInitialRowCount" #contextMenu
         [cacheBlockSize]="cacheBlockSize" [maxBlocksInCache]="maxBlocksInCache"
        (cellClicked)="tableMenuClick($event, $event.data, contextMenu,tenantMenuTemplate)" rowSelection='multiple'
        (rowSelected)="rowSelected($event)" [suppressContextMenu]="true" suppressRowClickSelection="true"
        [components]="components" (selectionChanged)="selectionChanged($event)" (filterChanged)="onFilterChanged()"
        [gridOptions]="gridOptions">
      </ag-grid-angular> -->
      <ag-grid-angular #contextMenu [style]="styleChipDiv" class="ag-theme-material user-managementt-grid"
        [rowHeight]="rowHeight" (gridReady)="onUserGridReady($event)" [columnDefs]="columnDefs" id="gridUsers"
        [defaultColDef]="defaultColDef" [cacheBlockSize]="cacheBlockSize" [maxBlocksInCache]="maxBlocksInCache"
        [rowModelType]="rowModelType" [sideBar]="sideBar"
        [infiniteInitialRowCount]="infiniteInitialRowCount" [paginationPageSize]="paginationPageSize"
        [overlayNoRowsTemplate]="overlayNoRowsTemplate" [gridOptions]="gridOptions"
        (cellClicked)="tableMenuClick($event, $event.data, contextMenu,tenantMenuTemplate)">
    </ag-grid-angular>
      <!-- ag grid end -->
    </div>
    <!-- ag grid div end -->

  <ng-template #tenantMenuTemplate let-user>
    <div>
      <ul class="mdc-list demo-list mdc-elevation--z2 b-white">
        <!-- //NOSONAR -->
         @if(this.userAuthService.checkPermission('MANAGE.USERS.ROLES')){
          <li class="mdc-list-item mdc-ripple-upgraded context-menu-heigth" (click)="editUser(user.extraProperties)" (keydown)="noop()">
            <span class="mdc-fab__icon material-icons context-menu-font-size">edit</span>&nbsp;&nbsp;Modify
          </li>
        }

        <li class="mdc-list-item mdc-ripple-upgraded context-menu-heigth unsetbottommargin removebottommargin"
          (click)="deleteDialog(user.extraProperties)" (keydown)="noop()">
          <span class="mdc-fab__icon material-icons context-menu-font-size">delete</span>&nbsp;&nbsp;Remove
        </li>
        @if(user.status.toLowerCase() === 'unapproved'){
        <li class="mdc-list-item mdc-ripple-upgraded context-menu-heigth unsetbottommargin removebottommargin"
          (click)="setUserStatus(user.extraProperties,true)" (keydown)="noop()">
          <span class="mdc-fab__icon material-icons context-menu-font-size">done</span>&nbsp;&nbsp;Approve User
        </li>
        }
        @if(user.status.toLowerCase() === 'approved'){
        <li class="mdc-list-item mdc-ripple-upgraded context-menu-heigth unsetbottommargin removebottommargin"
          (click)="setUserStatus(user.extraProperties,false)" (keydown)="noop()">
          <span class="mdc-fab__icon material-icons context-menu-font-size">remove_circle</span>&nbsp;&nbsp;Revoke User
          
        </li>
        }
      </ul>
    </div>
  </ng-template>

  <app-slider (closeSliderFunc)="closeNav()" [sliderHeader]="(editmode == true) ? 'Modify User' :  'Add User' ">
    <div *ngIf="editmode == false">
      <add-users [roleList]="roleList" (getUserDetails)=onAddModifySliderClose() (closeSlider)=closeNav()></add-users>
    </div>
    <div *ngIf="editmode == true">
      <add-users [roleList]="roleList" [editdata]="editRowInfo" (getUserDetails)=onAddModifySliderClose()
        (closeSlider)=closeNav()></add-users>
    </div>
    <ng-content></ng-content>
  </app-slider>